module.exports = __webpack_public_path__ + "static/media/github-api.475c8d36.svg";